import { default as RelayerComp } from "../components/relayer";
import PageWrap from "../ui/page-wrap";

export default function Relayer() {
  return (
    <PageWrap>
      <RelayerComp />
    </PageWrap>
  );
}
